import { localSettingObservable } from "../utils/localSettingObservable";

export class BenchmarkStore {
    @localSettingObservable("benchmark.video.decoder.wasm")
    public wasmDecoderSupported?: boolean;

    @localSettingObservable("benchmark.video.decoder.yuv")
    public webglYUVSupported?: boolean;

    @localSettingObservable("benchmark.video.decoder")
    public canDecodeVideo?: boolean;

    @localSettingObservable("benchmark.video.fps")
    public videoMaxFPS?: number;

    @localSettingObservable("benchmark.audio.opus")
    public opusPlaybackSupported?: boolean;

    @localSettingObservable("benchmark.audio.mp3")
    public mp3PlaybackSupported?: boolean;

    @localSettingObservable("benchmark.audio.wav")
    public wavPlaybackSupported?: boolean;

    @localSettingObservable("benchmark.network.download")
    public downloadMbs?: number;

    @localSettingObservable("benchmark.network.upload")
    public uploadMbs?: number;

    @localSettingObservable("benchmark.network.latency")
    public latency?: number;

    @localSettingObservable("benchmark.performance.webgl")
    public webglSupported?: boolean;

    @localSettingObservable("benchmark.performance.gpu")
    public gpuAcceleration?: boolean;

    @localSettingObservable("benchmark.performance.operations")
    public operationsPerSecond?: number;
}
